/* eslint-disable no-redeclare */
// 竞猜相关公共处理
export default {
    allMap: {
        SPF: "赛事胜平负",
        SPF_BC: "赛事半场胜平负",
        RQSF: "赛事让球胜负",
        RQSF_BC: "赛事半场让球胜负",
        DXQ: "赛事大小球",
        DXQ_BC: "赛事半场大小球",
        DXQ_CORNER: "赛事角球大小球",
        SF: "赛事胜负",
        RFSF: "赛事让分胜负",
        DXF: "赛事大小分",
        JCLQDXF: "竞彩大小分",
        JCLQRFSF: "竞彩让分胜负",
        JCLQSF: "竞彩胜负",
        JCRQSF: "竞彩让球胜平负",
        JCSPF: "竞彩胜平负",
        LQDXF: "赛事大小分",
        LQDXF_BC: "赛事半场大小分",
        LQRFSF: "赛事让分胜负",
        LQRFSF_BC: "赛事半场让分胜负",
        LQSF: "赛事胜负"
    },
    matchStateMap: {
        0: "未开",
        1: "上半场",
        2: "中场",
        3: "下半场",
        4: "加时",
        "-11": "待定",
        "-12": "腰斩",
        "-13": "中断",
        "-14": "推迟",
        "-1": "完赛",
        "-10": "取消"
    },
    LqMatchStateMap: {
        0: "未开",
        1: "第1节",
        2: "第2节",
        3: "第3节",
        4: "第4节",
        5: "加时1",
        6: "加时2",
        7: "加时3",
        8: "加时4",
        9: "加时5",
        "-1": "完场",
        "-2": "待定",
        "-3": "中断",
        "-4": "取消",
        "-5": "推迟",
        50: "中场"
    },
    dailyMap: {
        1: "大热",
        2: "悬殊",
        3: "同赔",
        4: "极限",
        5: "庄家态度",
        6: "Ai智篮",
        15: "大数据报告",
        16: "全维预测",
        17: "指数波动",
        18: "冷门分析",
        19: "情报速递",
        20: "数据雷达",
        11: "大数据报告",
        12: "全维预测",
        13: "赔率波动",
        14: "冷门分析",
        21: '泊松分布',
        22: '超级必发',
        23: 'Margin模型',
        24: '海外专家',
        25: '差异分析',
        26: '智能计划',
        27: '三场决胜'
    }
}
